export const json = {
  locale: 'pt_br',
  recipe: "Receita",
  machine: "Máquina",
  task: {
    state: {
      unset: "Não definido",
      todo: "A fazer",
      in_progress: "Em progresso",
      to_test: "Para testar",
      wont_fix: "Não será corrigido",
      done: "Concluído",
      paused: "Pausado",
    },
    priority: {
      unset: "Sem prioridade",
      low: "Baixa",
      normal: "Normal",
      high: "Alta",
      max: "Urgente",
    },
    table: {
      header: {
        title: "Tarefa",
        state: "Estado",
        priority: "Prioridade",
        labels: "Etiquetas",
      },
      placeholder: {
        filter: {
          priority: "Filtrar e-mails...",
        },
      },
      "no-results": "Sem resultados",
    },
    add: {
      title: "Adicionar nova tarefa",
      name: "Nome da tarefa",
      name_placeholder: "Digite o nome da tarefa",
      priority: "Prioridade",
      title_translations: "Traduções do título",
      description_translations: "Traduções da descrição",
      icon_url: "URL do ícone (opcional)",
      icon_url_placeholder: "Digite a URL do ícone",
      labels: "Etiquetas",
      assigned_to: "Atribuído a",
      assigned_to_placeholder: "Selecionar moderador",
      submit: "Criar tarefa",
      cancel: "Cancelar",
      edit_translations: "Editar traduções",
      save_translations: "Salvar traduções",
      required_field: "Este campo é obrigatório",
      en_us_required: "A tradução em inglês (EUA) é obrigatória",
      success: "Tarefa criada com sucesso!",
      error: "Erro ao criar a tarefa. Por favor, tente novamente.",
    },
  },
  table: {
    select: {
      of: "de",
      rows: "linha(s) selecionada(s).",
    },
  },
  cookies: {
    link: 'Política de Cookies',
    title: "Consentimento de cookies",
    description:
      "Este site usa cookies para garantir seu funcionamento adequado e melhorar sua experiência. Por favor, selecione quais cookies você nos permite usar.",
    policy_link: "Saiba mais em nossa Política de Cookies",
    accept_all: "Aceitar todos",
    accept_selected: "Aceitar selecionados",
    accept_essential: "Apenas essenciais",
    manage: "Gerenciar preferências",
    save: "Salvar preferências",
    back: "Voltar",
    categories: {
      essential: {
        title: "Cookies essenciais",
        description: "Estes cookies são necessários para o funcionamento do site e não podem ser desativados.",
      },
      functional: {
        title: "Cookies funcionais",
        description: "Estes cookies permitem recursos e funcionalidades personalizados.",
      },
      analytics: {
        title: "Cookies analíticos",
        description: "Estes cookies nos ajudam a entender como os visitantes interagem com o site.",
      },
      marketing: {
        title: "Cookies de marketing",
        description: "Estes cookies são usados para rastrear visitantes em sites para fins de publicidade.",
      },
    },
    expiration: {
      title: "Expiração de cookies",
      description: "Escolha por quanto tempo suas preferências de cookies serão lembradas:",
      thirty_days: "30 dias",
      ninety_days: "90 dias",
      six_months: "6 meses",
      one_year: "1 ano",
    },
    policy: {
      title: "Política de Cookies",
      introduction:
        "Esta Política de Cookies explica como usamos cookies e tecnologias semelhantes para reconhecê-lo quando você visita nosso site. Ela explica o que são essas tecnologias e por que as usamos, bem como seus direitos de controlar nosso uso delas.",
      what_are_cookies: "O que são cookies?",
      what_are_cookies_text:
        "Cookies são pequenos arquivos de dados que são colocados em seu computador ou dispositivo móvel quando você visita um site. Os cookies são amplamente utilizados pelos proprietários de sites para fazer seus sites funcionarem, ou funcionarem de maneira mais eficiente, bem como para fornecer informações de relatórios.",
      how_we_use: "Como usamos cookies",
      how_we_use_text:
        "Usamos cookies por várias razões. Alguns cookies são necessários por razões técnicas para que nosso site funcione, e os chamamos de cookies 'essenciais' ou 'necessários'. Outros cookies nos permitem rastrear e direcionar os interesses de nossos usuários para melhorar a experiência em nosso site. Terceiros servem cookies através do nosso site para publicidade, análise e outros fins.",
      types: "Tipos de cookies que usamos",
      managing: "Gerenciando seus cookies",
      managing_text:
        "Você pode configurar ou alterar os controles do seu navegador da web para aceitar ou recusar cookies. Se você optar por recusar cookies, ainda poderá usar nosso site, embora seu acesso a algumas funcionalidades e áreas do nosso site possa ser restrito. Como os meios pelos quais você pode recusar cookies através dos controles do seu navegador da web variam de navegador para navegador, você deve visitar o menu de ajuda do seu navegador para obter mais informações.",
      third_party: "Cookies de terceiros",
      third_party_text:
        "Além de nossos próprios cookies, também podemos usar vários cookies de terceiros para relatar estatísticas de uso do site, entregar anúncios no e através do site, e assim por diante.",
      updates: "Atualizações desta Política de Cookies",
      updates_text:
        "Podemos atualizar esta Política de Cookies de tempos em tempos para refletir, por exemplo, alterações nos cookies que usamos ou por outras razões operacionais, legais ou regulatórias. Portanto, visite novamente esta Política de Cookies regularmente para se manter informado sobre nosso uso de cookies e tecnologias relacionadas.",
      purpose: "Finalidade",
      essential_purpose:
        "Necessários para o funcionamento adequado do site. Estes cookies permitem funções básicas como navegação de páginas e acesso a áreas seguras do site.",
      functional_purpose:
        "Permitem que o site lembre das escolhas que você faz (como seu nome de usuário, idioma ou a região em que você está) e fornecem recursos aprimorados e mais pessoais.",
      analytics_purpose:
        "Nos ajudam a entender como os visitantes interagem com nosso site, coletando e relatando informações anonimamente.",
      marketing_purpose:
        "Usados para rastrear visitantes em sites. A intenção é exibir anúncios que sejam relevantes e envolventes para o usuário individual.",
      always_active: "Sempre ativo",
      active: "Ativo",
      inactive: "Inativo",
      back_to_site: "Voltar ao site",
    },
  },
  sidebar: {
    platform: "Plataforma",
    dashboard: "Painel",
    tasks: {
      title: "Tarefas",
      add: "Adicionar tarefa"
    },
    analytics: "Análises",
    users: "Usuários",
    settings: "Configurações",
    admin_panel: {
      title: "Painel de administração",
      mods: {
        title: "Moderadores",
        add: "Adicionar moderador"
      },
      labels: {
        title: "Etiquetas",
        add: "Adicionar etiqueta"
      },
      pending: "Aprovações pendentes"
    },
    documentation: {
      title: "Documentações",
      create: "Criar documentação"
    },
    search: "Pesquisar em documentos..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Visão geral",
          userInfo: "Informações do usuário",
          userId: "ID do usuário",
          role: "Função",
          memberSince: "Membro desde"
        },
        tasks: {
          title: "Tarefas",
          assigned: "Tarefas atribuídas",
          noTasks: "Ainda não há tarefas atribuídas."
        },
        activity: {
          title: "Atividade",
          recent: "Atividade recente",
          noActivity: "Nenhuma atividade recente."
        },
        settings: {
          title: "Configurações",
          user: "Configurações do usuário",
          admin: "Configurações de administrador para este usuário."
        }
      }
    },
    mods: {
      error: {
        unknownError: "Erro desconhecido"
      },
      access: {
        title: "Acesso negado",
        description: "Você não tem permissão para acessar esta página."
      },
      add: {
        link: "Adicionar novo mod",
        title: "Adicionar novo mod",
        addDesc: "Criar uma nova entrada de mod",
        name: {
          title: "Nome",
          placeholder: "Digite o nome do mod"
        },
        description: {
          title: "Descrição",
          placholder: "Digite a descrição em "
        },
        optional: "Opcional",
        versions: {
          title: "Versões",
          add: "Adicionar versão"
        },
        icon: "URL do ícone",
        launchers: "Lançadores",
        form: {
          errors: {
            alert: {
              title: "Erro",
              description: "Por favor, corrija os erros acima antes de enviar."
            },
            name: "O nome é obrigatório",
            description: "A descrição em inglês (EUA) é obrigatória",
            curseforge: "O link do CurseForge é obrigatório",
            invalidURL: "Formato de URL inválido",
            versions: "Pelo menos uma versão é necessária",
            launchers: "Pelo menos um lançador é necessário"
          }
        },
        cancel: "Cancelar",
        create: {
          loading: "Criando...",
          default: "Criar mod"
        },
        langDataError: "Erro ao carregar dados de idioma:",
      },
      noMods: "Nenhum mod encontrado",
      getStarted: "Comece criando um novo mod.",
      fetch: {
        error: 'Erro ao buscar documentação:'
      },
      "delete": {
        link: "Excluir",
        confirm: "Tem certeza de que deseja excluir este mod?"
      },
      toast: {
        delete: {
          success: {
            title: "Mod excluído",
            description: "O mod foi excluído com sucesso."
          },
          error: {
            console: "Erro ao excluir o mod:",
            fallback: "Falha ao excluir o mod",
            title: "Erro",
            description: "Ocorreu um erro ao excluir o mod."
          }
        },
        edit: {
          success: {
            title: "Sucesso",
            description: "Mod atualizado com sucesso"
          }
        },
        add: {
          fallback: "Falha ao criar o mod",
          success: {
            title: "Sucesso",
            description: "Mod criado com sucesso"
          },
          console: "Erro ao criar o mod:",
          error: {
            title: "Erro",
            description: "Falha ao criar o mod"
          }
        }
      },
      noDesc: "Nenhuma descrição disponível",
      docs: {
        link: "Documentação"
      },
      edit: {
        link: "Editar",
        title: "Editar mod",
        langDataError: "Erro ao carregar dados de idioma:",
        notFound: "Mod não encontrado",
        failFetch: "Falha ao buscar o mod",
        unknownError: "Ocorreu um erro desconhecido",
        form: {
          errors: {
            name: "O nome é obrigatório",
            description: "A descrição em inglês (EUA) é obrigatória",
            curseforge: "O link do CurseForge é obrigatório",
            versions: "Todos os campos de versão devem ser preenchidos",
            launchers: "Pelo menos um lançador deve ser selecionado"
          }
        },
        modInfo: "Informações do mod",
        editModInfo: "Editar as informações do mod.",
        name: "Nome",
        description: {
          title: "Descrição",
          required: "A descrição em inglês (EUA) é obrigatória."
        },
        optional: "Opcional",
        versions: {
          title: "Versões",
          add: "Adicionar versão",
          remove: "Remover"
        },
        icon: "URL do ícone",
        launchers: "Lançadores",
        cancel: "Cancelar",
        update: "Atualizar mod"
      }
    },
    docs: {
      access: {
        title: "Acesso negado",
        description: "Você não tem permissão para acessar esta página."
      },
      title: "Documentação",
      description: "Navegue e leia documentação para mods de Minecraft",
      create: {
        link: "Criar documentação",
        tab: "Criar nova",
        content: {
          title: "Nenhum mod disponível",
          description: "Todos os mods já têm documentação ou você não tem permissão para criar documentação para nenhum mod."
        },
        title: "Criar documentação"
      },
      published: "Publicado",
      pending: "Pendente",
      noDocs: {
        title: "Nenhuma documentação disponível",
        description: "Ainda não há páginas de documentação publicadas."
      },
      noPending: {
        title: "Nenhuma documentação pendente",
        superAdmin: "Não há páginas de documentação aguardando aprovação",
        rest: "Você não tem páginas de documentação pendentes."
      },
      user: {
        noDocs: {
          title: "Nenhuma documentação disponível",
          description: "Ainda não há páginas de documentação publicadas."
        }
      },
      card: {
        pending: "Aguardando aprovação",
        view: "Ver",
        edit: "Editar"
      },
      add: {
        title: "Criar nova documentação",
        description: "Crie documentação abrangente para um mod de Minecraft",
        noMods: {
          title: "Nenhum mod disponível",
          description: "Não há mods disponíveis para criação de documentação. Ou todos os mods já têm documentação ou você não tem permissão para criar documentação para nenhum mod."
        },
        card: {
          title: "Informações básicas",
          description: "Forneça informações básicas sobre a documentação.",
          descriptionLink: "Veja nosso guia de documentação",
          content: {
            modSelect: "Selecionar um mod",
            modSelectDesc: "Selecione o mod para o qual você deseja criar documentação",
            noDesc: "Nenhuma descrição disponível",
            form: {
              title: {
                title: "Título",
                placeholder: "Digite o título da documentação",
                description: "O título da sua documentação (inglês EUA é obrigatório)"
              },
              description: {
                title: "Descrição",
                placeholder: "Digite a descrição da documentação",
                description: "Uma breve descrição da sua documentação (inglês EUA é obrigatório)"
              },
              coverImage: {
                title: "URL da imagem de capa (Opcional)",
                description: "Forneça uma URL para a imagem de capa da sua documentação"
              },
              tabs: {
                preview: {
                  title: "Pré-visualização",
                  content: {
                    title: "Pré-visualização",
                    description: "Pré-visualização de como sua documentação ficará",
                    form: {
                      title: "Título da documentação",
                      description: "A descrição da documentação aparecerá aqui."
                    },
                    section: "seção",
                    article: "artigo",
                    modSelect: {
                      title: "Selecionar um mod",
                      description: "Selecione um mod para pré-visualizar sua documentação"
                    }
                  }
                },
                information: {
                  title: "Informações",
                  content: {
                    title: "Informações",
                    description: "Informações importantes sobre a criação de documentação",
                    approval: {
                      title: "Aprovação necessária",
                      description: "A documentação criada por editores e administradores requer aprovação de um super administrador antes de se tornar pública. Abra um ticket para solicitar isso."
                    },
                    after: {
                      title: "Após a criação:",
                      list: {
                        one: "Você será redirecionado para o editor de documentação",
                        two: "Uma seção e um artigo padrão serão criados automaticamente",
                        three: "Você pode adicionar mais seções e artigos conforme necessário",
                        four: "Você pode fazer upload de imagens e adicionar componentes personalizados",
                        five: "Você pode pré-visualizar sua documentação antes de enviá-la para aprovação. (Ela deve ser salva antes da pré-visualização)"
                      }
                    },
                    create: {
                      loading: "Criando...",
                      default: "Criar documentação"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Falha ao buscar mods",
          documentation: "Falha ao buscar documentações"
        },
        success: {
          title: "Documentação criada",
          description: "Sua documentação foi criada com sucesso."
        },
        error: {
          fetching: {
            mods: {
              console: "Erro ao buscar mods:",
              toast: {
                title: "Erro",
                description: "Falha ao carregar mods. Por favor, tente novamente."
              }
            }
          },
          creating: {
            failed: "Falha ao criar documentação",
            error: {
              console: "Erro ao criar documentação:",
              toast: {
                title: "Erro",
                description: "Falha ao criar documentação. Por favor, tente novamente."
              }
            }
          }
        }
      }
    }
  }
}